<template src="./onlineTestQuestions.html"></template>

<script>
import showStatus from '../../../NetworkManager/showStatus'
// import { v4 } from "uuid";
import UploadToDigitalOceanRepository from '../../../Repository/UploadToDigitalOcean';
import apiV3 from "../../../NetworkManager/apiV3";
import NbaRepository from "../../../Repository/NBA";
import { generateFromJsonMultiselect, generateJsonFromExcel } from '../../../utils/excel';

export default {
  name: "onlineTestQuestions",
  props: [
    "prop_selectedSubjectId",
    "prop_tabNumber",
    "prop_allSubjects",
    "prop_subjectCode",
    "selected_item"
  ],
  data() {
    return {
      testId: '',
      test: {},
      userData: {},
      selectedInstitute: {},
      selectedSemester: {},
      selectedObjectTest: {},
      questionsArray: [],
      testQuestions: {},
      uploadQuestionsViaExcel: false,
      questionsExcelFile: null,
      tempQuestions: [],
      excelErrors: [],
      cos: [],
      excelLink: "",
      blooms: ["CREATE (C)", "EVALUATE (E)", "ANALYZE (A)", "APPLY (Ap)", "UNDERSTAND (U)", "REMEMBER (R)"],
      isDisabled: false,
      headers: [
        { text: "Qn No", value: "questionNumber", align: "center", width: "4%", sortable: false },
        { text: "Marks", value: "questionMarks", align: "center", width: "7%", sortable: false },
        { text: "Statement", value: "question", align: "center", width: "30%", sortable: false },
        { text: "Number of Options", value: "numberOfOptions", align: "center", width: "4%", sortable: false },
        { text: "Options", value: "options", align: "center", width: "30%", sortable: false },
        { text: "Correct Ans", value: "correctAnswer", align: "center", width: "15%", sortable: false },
        { text: "Attachment", value: "attachment", align: "center", width: "12%", sortable: false },
        { text: "Map COs", value: "cos", align: "center", width: "12%", sortable: false },
        { text: "Map Blooms", value: "blooms", align: "center", width: "12%", sortable: false },
        { text: "", value: "delete", align: "left", width: "6%", sortable: false }
    ],
    attachmentLoading: false,
    nbaData: []
    };
  },
  async created() {
    await this.initializeData();
  },
  async activated() {
    const testDetailsChanged = this.$store.state.liveData.testDetailsChanged;
    if (
      testDetailsChanged.basicDetails ||
      testDetailsChanged.questions ||
      testDetailsChanged.studentAllocation
    ) {
      await this.initializeData();
    }
  },
  methods: {
    async initializeData() {
      try {
        this.userData = this.$store.getters["user/get_userData"];
        this.uploadToDigitalOceanInstance = new UploadToDigitalOceanRepository(this);
        this.nbaRepositoryInstance = new NbaRepository(this);
        this.selectedInstitute = this.$store.getters["instituteData/get_selectedInstitute"];
        this.selectedSemester = this.$store.getters["instituteData/get_selectedSemester"];
        this.selectedObjectTest = this.$store.getters["liveData/get_selectedObjectTest"];
        console.log("this.selectedObjectTestQuestions", this.selectedObjectTest);

        this.testId = this.$store.getters["liveData/get_testId"];

        // Check if the test is editable or disabled based on date
        if (this.selectedObjectTest?.editTest) {
          const testDate = this.selectedObjectTest?.prop_onlineTest?.dateTimeUTC;
          if (testDate && new Date(testDate) < new Date()) {
            this.isDisabled = true;
          }
        }

        // Fetch test details
        await this.fetchTest();

        console.log(
          "this.selectedObjectTest?.prop_onlineTest?.totalMarks",
          this.selectedObjectTest?.prop_onlineTest?.totalMarks,
          this.test?.data?.totalMarks
        );

        // Fetch NBA data
        this.nbaData = await this.nbaRepositoryInstance.getCos({
          lmsInstituteId: this.selectedInstitute,
          semesterId: this.selectedSemester.semId,
          subjectId: this.selectedObjectTest.prop_selectedSubject.subjectId
        });

        console.log('this.nbaData', this.nbaData);

        // Populate CO numbers
        this.cos = this.nbaData?.data ? this.nbaData.data.map((item) => `CO${item.CONumber}`) : [];
      } catch (e) {
        console.error("Error during initialization", e);
      }
    },
    async fetchTest() {
      try {
        if (this.selectedObjectTest?.prop_onlineTest?._id) {
          this.$store.commit("liveData/set_testId", this.selectedObjectTest.prop_onlineTest._id);
          this.testId = this.selectedObjectTest.prop_onlineTest._id
          this.test = await apiV3.postRequest('/exam/getExamById', { testId: this.testId });
          console.log('this.test', this.test);
          await this.fetchQuestions()
        } else {
          this.test = await apiV3.postRequest('/exam/getExamById', { testId: this.testId });
          console.log('this.test', this.test);
        }
      } catch (e) {
        console.error('Error in fetching test', e);
      }
    },
    async fetchQuestions() {
      try {
        this.testQuestions = await apiV3.getRequest('/exam/getQuestionsByExam', { examId: this.testId });
        console.log('this.testQuestions', this.testQuestions);
        this.fillQuestionsData()
      } catch (e) {
        console.error('Error in fetching questions', e);
      }
    },
    async downloadSampleQuestionsExcel() {
      // const data = [];
      this.excelErrors = []
      // const objToPush = {
      //   "Qn No": '',
      //   Marks: '',
      //   Question: '',
      //   "Option 1": '',
      //   "Option 2": '',
      //   "Option 3": '',
      //   "Option 4": '',
      //   "Option 5": '',
      //   "Option 6": '',
      //   "Correct Ans": '',
      //   // Attachment: '',
      //   "Map COs": '',
      //   "Map Blooms": ''
      // }
      // data.push(objToPush);
      // this.excelLink = createExcelThroughJson(data, this.test?.data?.name + '_sample_Excel')
      const schema = {
        Sheet1: {
          "Qn No*": {
            validation: {
              type: 'textLength',
              required: true
            },
            variableName: 'questionNumber'
          },
          'Marks*': {
            validation: {
              type: 'textLength',
              required: true
            },
            variableName: 'marks'
          },
          'Question*': {
            validation: {
              type: 'textLength',
              required: true
            },
            variableName: 'question'
          },
          "Option 1*": {
            validation: {
              type: 'textLength',
              required: true
            },
            variableName: 'option1'
          },
          "Option 2*": {
            validation: {
              type: 'textLength',
              required: true
            },
            variableName: 'option2'
          },
          "Option 3": {
            validation: {
              type: 'textLength'
            },
            variableName: 'option3'
          },
          "Option 4": {
            validation: {
              type: 'textLength'
            },
            variableName: 'option4'
          },
          "Option 5": {
            validation: {
              type: 'textLength'
            },
            variableName: 'option5'
          },
          "Option 6": {
            validation: {
              type: 'textLength'
            },
            variableName: 'option6'
          },
          "Correct Ans*": {
            validation: {
              type: 'textLength',
              required: true
            },
            variableName: 'answer'
          },
          "Map COs": {
            validation: {
              type: 'list',
              values: this.cos
            },
            variableName: 'cos'
          },
          "Map Blooms": {
            validation: {
              type: 'list',
              values: this.blooms
            },
            variableName: 'blooms'
          }
        }
      };
      this.excelLink = await generateFromJsonMultiselect(schema)
      const link = document.createElement('a');
      link.href = this.excelLink;
      link.download = `${this.test.data.name}.xlsx`;
      link.click();
    },
    checkFile() {
      if (!this.questionsExcelFile) {
        this.excelErrors = []
      }
    },
    async handleParseQuestionsExcel() {
      this.excelErrors = []
      // this.questionsArray = [];
      const schema = {
        Sheet1: {
          "Qn No*": {
            validation: {
              type: 'textLength',
              required: true
            },
            variableName: 'questionNumber'
          },
          'Marks*': {
            validation: {
              type: 'textLength',
              required: true
            },
            variableName: 'marks'
          },
          'Question*': {
            validation: {
              type: 'textLength',
              required: true
            },
            variableName: 'question'
          },
          "Option 1*": {
            validation: {
              type: 'textLength',
              required: true
            },
            variableName: 'option1'
          },
          "Option 2*": {
            validation: {
              type: 'textLength',
              required: true
            },
            variableName: 'option2'
          },
          "Option 3": {
            validation: {
              type: 'textLength'
            },
            variableName: 'option3'
          },
          "Option 4": {
            validation: {
              type: 'textLength'
            },
            variableName: 'option4'
          },
          "Option 5": {
            validation: {
              type: 'textLength'
            },
            variableName: 'option5'
          },
          "Option 6": {
            validation: {
              type: 'textLength'
            },
            variableName: 'option6'
          },
          "Correct Ans*": {
            validation: {
              type: 'textLength',
              required: true
            },
            variableName: 'answer'
          },
          "Map COs": {
            validation: {
              type: 'list',
              values: this.cos
            },
            variableName: 'cos'
          },
          "Map Blooms": {
            validation: {
              type: 'list',
              values: this.blooms
            },
            variableName: 'blooms'
          }
        }
      };

      try {
        const res = await generateJsonFromExcel(this.questionsExcelFile, schema, false);
        const { data } = res;
        const { Sheet1 } = data;

        // let totalQuestionsMarks = 0;
        const questions = [];

        for (const obj of Sheet1) {
          let hasError = false;

          // Validate required fields
          if (!obj?.questionNumber) {
            this.excelErrors.push('A question is missing the "Qn No" field.');
            hasError = true;
          }
          if (!obj?.marks) {
            this.excelErrors.push(`Question ${obj?.questionNumber || 'unknown'} is missing the "Marks" field.`);
            hasError = true;
          }
          if (!obj?.question) {
            this.excelErrors.push(`Question ${obj?.questionNumber || 'unknown'} is missing the "Question" field.`);
            hasError = true;
          }
          if (!obj?.answer) {
            this.excelErrors.push(`Question ${obj?.questionNumber || 'unknown'} is missing the "Correct Answer" field.`);
            hasError = true;
          }

          // Process options
          const optionsArray = [
            obj?.option1,
            obj?.option2,
            obj?.option3,
            obj?.option4,
            obj?.option5,
            obj?.option6
          ].filter((option) => option !== undefined && option !== null);

          if (optionsArray.length === 0) {
            this.excelErrors.push(`Question ${obj?.questionNumber || 'unknown'} has no options provided.`);
            hasError = true;
          }

          // Validate correct answer
          const correctAnswer = optionsArray.includes(obj?.answer) ? obj?.answer : null;
          if (!correctAnswer && obj?.answer) {
            this.excelErrors.push(`Correct Answer for Question ${obj?.questionNumber || 'unknown'} does not match any options.`);
            hasError = true;
          }

          // Validate COs and Blooms
          const selectedCos = obj?.cos ? obj.cos.split(',') : [];
          const selectedBlooms = obj?.blooms ? obj.blooms.split(',') : [];
          // totalQuestionsMarks += obj.marks;
          if (!hasError) {
            const questionObj = {
              questionNumber: obj?.questionNumber,
              questionMarks: obj?.marks,
              question: obj?.question,
              numberOfOptions: optionsArray.length,
              options: optionsArray,
              correctAnswer: String(correctAnswer),
              // attachment: obj?.attachment,
              selectedCos: selectedCos,
              selectedBlooms: selectedBlooms
            };

            // Handle attachment
            // if (questionObj?.attachment) {
            //   await this.handleFileInputChange(questionObj);
            // }

            questions.push(questionObj);
          }
        }

        // Validate total marks
        // if (totalQuestionsMarks !== Number(this.test?.data?.totalMarks)) {
        //   console.log('totalQuestionsMarks', totalQuestionsMarks, this.test?.data?.totalMarks);
        //   this.excelErrors.push(`The total marks from questions (${totalQuestionsMarks}) exceed or do not match the total exam marks (${this.test?.data?.totalMarks}).`);
        // }

        // Finalize if no errors
        if (this.excelErrors.length === 0) {
          this.questionsArray = [...this.questionsArray, ...questions];
          this.uploadQuestionsViaExcel = false;
          this.questionsExcelFile = null;
          console.log('Sheet1', Sheet1);
        }
      } catch (error) {
        console.error('Error parsing questions from Excel:', error);
        this.excelErrors.push('An error occurred while processing the Excel file.');
      }
    },
    fillQuestionsData() {
      this.questionsArray = [];
      this.testQuestions.questions.forEach((question) => {
        console.log('question?.attachment', question);

        const questionObj = {
          questionNumber: question?.questionNumber,
          questionMarks: question?.marks,
          question: question?.question,
          numberOfOptions: question?.options?.length,
          options: question?.options,
          correctAnswer: String(question?.answer),
          attachment: question?.attachment,
          selectedCos: question?.cos,
          selectedBlooms: question?.blooms,
          _id: question?._id
        };
        this.questionsArray.push(questionObj);
      });
    },
    updateOptionsArray(item) {
      if (Number(item.numberOfOptions) && Number(item.numberOfOptions) <= 6) {
        console.log('Number(item.numberOfOptions)', Number(item.numberOfOptions));
        if (item.options.length > Number(item.numberOfOptions)) {
            item.options.splice(Number(item.numberOfOptions))
        } else if (item.options.length < Number(item.numberOfOptions)) {
            while (item.options.length < Number(item.numberOfOptions)) {
                item.options.push("")
            }
        }
      } else if (Number(item.numberOfOptions)) {
        showStatus("Number Of Options can not be greater than 6.", 4000, "error", this)
      } else {
        showStatus("Number Of Options can not be empty.", 4000, "error", this)
      }
    },
    addQuestion() {
      const question = {
        questionNumber: null,
        questionMarks: null,
        question: "",
        numberOfOptions: null,
        options: [],
        correctAnswer: "",
        attachment: null,
        cos: [],
        blooms: []
      };
      this.questionsArray.push(question);
    },
    async handleFileInputChange(item) {
      console.log('item', item);
      if (item.attachment) {
        this.attachmentLoading = true;
        const linkObj = await this.uploadFile([...item.attachment]);
        item.attachmentToAdd = linkObj;
        this.attachmentLoading = false;
      }
    },
    async uploadFile(fileArr) {
      try {
        if (fileArr.length > 0) {
          return await this.uploadToDigitalOceanInstance.upload(fileArr, this.userData.uId);
        }
      } catch (error) {
        console.error('Error uploading file:', error);
        return [];
      }
    },
    async validateQuestions() {
      const testDetailsChanged = this.$store.state.liveData.testDetailsChanged;
      testDetailsChanged.question = true;
      this.$store.commit("liveData/set_testDetailsChanged", testDetailsChanged);
      if (this.questionsArray.length > 0) {
        let validationPassed = true
        let totalMarksOfQuestions = 0
        this.questionsArray.forEach((question) => {
          const reference = `Question ${question.questionNumber || "N/A"}`;
          if (!question.questionNumber) {
            validationPassed = false;
            showStatus(`${reference}: Question number is required.`, 4000, "error", this);
            return;
          }
          if (question.question === "") {
            validationPassed = false;
            showStatus(`${reference}: Question statement is required.`, 4000, "error", this);
            return;
          }
          if (question.questionMarks === "") {
            validationPassed = false;
            showStatus(`${reference}: Marks for the question are required.`, 4000, "error", this);
            return;
          }
          if (question.numberOfOptions === "" || question.numberOfOptions < 2 || question.numberOfOptions > 6) {
            validationPassed = false;
            showStatus(
              `${reference}: Number of options must be between 2 and 6.`,
              4000,
              "error",
              this
            );
            return;
          }
          if (!Array.isArray(question.options) || question.options.length === 0) {
            validationPassed = false;
            showStatus(
              `${reference}: Options must be a valid non-empty array.`,
              4000,
              "error",
              this
            );
            return;
          }
          if (
            question.options.some(
              (option) =>
                (typeof option !== "string" && typeof option !== "number") ||
                (typeof option === "string" && option.trim() === "")
            )
          ) {
            validationPassed = false;
            showStatus(
              `${reference}: All options must be valid non-empty strings or numbers.`,
              4000,
              "error",
              this
            );
            return;
          }

          if (question.correctAnswer === "") {
            validationPassed = false;
            showStatus(
              `${reference}: Correct answer is required for this question.`,
              4000,
              "error",
              this
            );
            return;
          }
          totalMarksOfQuestions += Number(question.questionMarks);
        });

        if (validationPassed) {
          if (
            Number(totalMarksOfQuestions) ===
              Number(this.selectedObjectTest?.prop_onlineTest?.totalMarks) ||
            Number(totalMarksOfQuestions) === Number(this.test?.data?.totalMarks)
          ) {
            await this.saveQuestions();
          } else {
            console.log('totalMarksOfQuestions', Number(totalMarksOfQuestions), this.selectedObjectTest?.prop_onlineTest?.totalMarks, Number(this.test?.data?.totalMarks));
            showStatus(
              "Total marks of all questions must equal the total marks of the exam.",
              4000,
              "error",
              this
            );
          }
        }
      } else if (this.tempQuestions.length > 0 && this.tempQuestions[0].questionNumber) {
        try {
          const updatedTest = await apiV3.putRequest("/exam/clearQuestions", { questions: [], examId: this.testId });
          if (updatedTest) showStatus("Questions removed successfully", 2000, "success", this);
          this.tempQuestions = []
        } catch (e) {
          console.error(e)
        }
      } else {
        showStatus("No questions found to save.", 4000, "error", this);
      }
    },
    async saveQuestions() {
      try {
        const questionsToSave = []
        if (this.questionsArray && Array.isArray(this.questionsArray)) {
          this.questionsArray.forEach((question) => {
            const newQuestion = {
              questionNumber: question.questionNumber,
              question: question.question,
              marks: Number(question.questionMarks),
              type: "mcq",
              options: question?.options,
              answer: String(question?.correctAnswer),
              cos: question?.selectedCos,
              blooms: question?.selectedBlooms
            };
            if (question?.attachmentToAdd?.length > 0) {
              newQuestion.attachment = question?.attachmentToAdd[0];
            }
            if (question?._id) {
              newQuestion._id = question?._id;
            }
            questionsToSave.push(newQuestion);
          });
        }
        const testObject = {}
        testObject.examId = this.testId
        testObject.questions = questionsToSave
        testObject.status = "published"
        if (questionsToSave?.length > 0) {
          if (this.selectedObjectTest?.editTest) {
            const updatedTest = await apiV3.putRequest("/exam/updateQuestions", { questions: questionsToSave, examId: this.testId });
            if (updatedTest) showStatus("Questions added successfully", 2000, "success", this);
            else showStatus("Error in adding questions", 4000, "error", this);
          } else {
            const updatedTest = await apiV3.putRequest("/exam/update", testObject);
            if (updatedTest) showStatus("Questions added successfully", 2000, "success", this);
            else showStatus("Error in adding questions", 4000, "error", this);
          }
        } else showStatus("Add questions first", 4000, "warning", this);
      } catch (e) {
        console.error('Error in saving questions', e);
      }
    },
    async goToNextTab() {
      this.$emit('conduction-changed', null, 2);
    },
    rowClass() {
      return "custom-row-class";
    },
    fieldBackgroundColors(item) {
      return "#9205050D";
    },
    isSpecialQuestion(item) {
      return item.question === "Solve any_out of" || item.tryl;
    },
    updateMarks(item, index) {
      // Handle marks update logic
    },
    deleteQuestion(index) {
      this.tempQuestions = [...this.questionsArray]
      this.questionsArray.splice(index, 1);
    },
    addSection() {
      // Logic to add a new section
    }
  }
};
</script>

<style src="./onlineTestQuestions.css"></style>
